// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__15_fE","header":"PatientQuestionnaire_header__8Rgpl","info":"PatientQuestionnaire_info__ea0-o"};